import { render } from "./CookiePolicyView.vue?vue&type=template&id=7dffdbfa&scoped=true"
const script = {}

import "./CookiePolicyView.vue?vue&type=style&index=0&id=7dffdbfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dffdbfa"]])

export default __exports__